/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Olive_Goat_SingInputs */

const en_wry_olive_goat_sing = /** @type {(inputs: Wry_Olive_Goat_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new Member`)
};

const de_wry_olive_goat_sing = /** @type {(inputs: Wry_Olive_Goat_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Benutzer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add new Member" |
*
* @param {Wry_Olive_Goat_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_olive_goat_sing = /** @type {((inputs?: Wry_Olive_Goat_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Olive_Goat_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_olive_goat_sing(inputs)
	return de_wry_olive_goat_sing(inputs)
});